// extracted by mini-css-extract-plugin
export default {"selectimagebutton":"selectimage_selectimagebutton__ZePeH","wrong":"selectimage_wrong__hxlt+","shake":"selectimage_shake__f25pE","selectimage":"selectimage_selectimage__TJ7-u"};